import { render, staticRenderFns } from "./IconSpark.vue?vue&type=template&id=0f8d41a6&"
import script from "./IconSpark.vue?vue&type=script&lang=js&"
export * from "./IconSpark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports